module.exports = __webpack_public_path__ + "static/d4-aa6befb498eebf515f3a36b6581057c6.jpg";